import $ from 'jquery';
import '@fancyapps/fancybox';

export const init = () => {

	$('[data-fancybox][data-type="ajax"]').fancybox({
		afterShow: function(obj) {
			obj.current.$content.trigger('contentload');
		},
	});

};
